import * as React from 'react';
import { Component } from 'react';
import { inject, observer } from 'mobx-react';
import { action, computed, observable } from 'mobx';
import { sortString } from '../utils';
import { translate } from './Translate';
import { FilterValue, FilterSearchKeys } from '../models/components/Filter';

// Higher-order component to return a filter with data and methods required to function
const withFilter = WrappedComponent => {
    @inject('translations')
    @inject('dataStore')
    @inject('filterStore')
    @observer
    class FilterItem extends Component<any> {
        @observable search: string = '';
        @observable expanded: boolean = this.props.dataStore.config.filtersTop
            ? false
            : this.props.filter.hasOwnProperty('expanded')
            ? this.props.filter.expanded
            : true;
        @observable clearIndividualFilters: boolean = this.props.dataStore
            .config.clearIndividualFilters;

        @computed
        get filterSearchKey(): FilterSearchKeys {
            return this.props.filter.filterSearchKey;
        }

        @computed
        get values(): Array<FilterValue> {
            return this.props.filter.values || [];
        }

        @computed
        get filteredValues(): Array<FilterValue> {
            return this.values
                .filter(value =>
                    value.label
                        .toLowerCase()
                        .includes(this.search.toLowerCase())
                )
                .filter(
                    value =>
                        !this.props.filterStore.isChecked(
                            this.props.filter.property,
                            value.value,
                            this.props.filter.filterSearchKey
                        )
                )
                .sort((a, b) => sortString(a.label, b.label));
        }

        @computed
        get filteredCount(): number {
            return this.filteredValues.length + this.selectedValues.length;
        }

        @computed
        get selectedValues(): Array<FilterValue> {
            return this.values
                .filter(value =>
                    this.props.filterStore.isChecked(
                        this.props.filter.property,
                        value.value,
                        this.props.filter.filterSearchKey
                    )
                )
                .sort((a, b) => sortString(a.label, b.label));
        }

        @computed
        get filterDropdownText(): string {
            return this.selectedValues.length
                ? this.selectedValues
                      .map(value =>
                          translate(this.props.translations, value.label)
                      )
                      .join(', ')
                : translate(this.props.translations, 'Select filters');
        }

        @computed
        get enableSearch(): boolean {
            return this.props.filter.enableSearch ? true : false;
        }

        @action
        toggleExpanded = () => {
            this.expanded = !this.expanded;
        };

        @action
        filterSearch = (value: string) => {
            this.search = value;
        };

        @action
        clearSearch = () => {
            this.search = '';
        };

        render() {
            return (
                <WrappedComponent
                    expanded={this.expanded}
                    toggleExpanded={this.toggleExpanded}
                    selectedCount={this.selectedValues.length}
                    total={this.values.length}
                    search={this.search}
                    clearSearch={this.clearSearch}
                    selectedValues={this.selectedValues}
                    filteredValues={this.filteredValues}
                    filterSearch={this.filterSearch}
                    enableSearch={this.enableSearch}
                    filterDropdownText={this.filterDropdownText}
                    {...this.props}
                />
            );
        }
    }

    return FilterItem;
};

export default withFilter;



// WEBPACK FOOTER //
// ./src/Components/withFilter.tsx